// CreditNoteVersionsPanel — thin wrapper over the shared VersioningPanel.
//
// The Credit Note domain configuration is the only thing that lives
// here. Every UX detail (timeline, diff, modal, aggregate banner)
// comes from `components/versioning/*`.
import React from 'react';
import VersioningPanel from './versioning/VersioningPanel';

const CREDIT_NOTE_CONFIG = {
  endpointBase: '/credit-notes',
  idField: 'id',
  numberKey: 'credit_note_number',
  entityLabel: 'الإشعار',
  actionAmend: 'credit_note.amend',
  actionAmendPost: 'credit_note.amend.post',
  testIdPrefix: 'cn',
  accentClass: 'bg-violet-600 hover:bg-violet-700',
  amendableFields: [
    { key: 'notes',        label: 'ملاحظات',     type: 'textarea' },
    { key: 'reason',       label: 'السبب',       type: 'text' },
    { key: 'amount',       label: 'المبلغ (الصافي)', type: 'number' },
    { key: 'tax_amount',   label: 'الضريبة',     type: 'number' },
    { key: 'total_amount', label: 'الإجمالي',    type: 'number' },
  ],
  financialFields: new Set(['amount', 'tax_amount', 'total_amount']),
  headlineFieldOrder: ['total_amount', 'amount', 'tax_amount'],
};

export default function CreditNoteVersionsPanel({ creditNote, onUpdated }) {
  return (
    <VersioningPanel
      entity={creditNote}
      config={CREDIT_NOTE_CONFIG}
      onUpdated={(data) => onUpdated && onUpdated(data?.credit_note || data)}
    />
  );
}
